import React, { useMemo } from 'react'
import styles from './hmlBar.module.scss'

const isHML = () => process.env.ENV === 'stage'

const HMLBar = () => {
  const shouldNotRender = useMemo(() => !isHML())

  if (shouldNotRender) return null

  return (
    <h3 className={styles.hmlBar}>
      Ambiente de Stage do ConsultorMais, caso tenha chegado aqui por engano,
      por favor acesse:{' '}
      <a href="https://www.consultormais.com">https://www.consultormais.com.</a>
    </h3>
  )
}

export default HMLBar
